module.exports = __webpack_public_path__ + "static/media/gwc-24-digital-agenda-splash-screen.be4c4791.jpg";